import { ROUTES } from "../shared/utils";

import { ProtectedRoute } from "../shared/pages";

import { AppLayout } from "../shared/layouts";
import { HomeLayout } from "../shared/layouts/HomeLayout";

import { Dashboard } from "../features/dashboard";
import { ProgrammeDashboard } from "../features/programmeDashboard";
import { Geospatial } from "../features/geospatial";
import { GeospatialProjects } from "../features/geospatialProjects";
import { InvestmentOversight } from "../features/investmentOversight";
import { ForecastVariance } from "../features/forecastVariance";

export const homeRoutes = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <HomeLayout title="Home" />,
        children: [{ path: ROUTES.DASHBOARD, element: <Dashboard /> }],
      },
      {
        element: <AppLayout title="Programme Dashboard" />,
        children: [{ path: ROUTES.PROGRAMME_DASHBOARD, element: <ProgrammeDashboard /> }],
      },
      {
        element: <AppLayout title="Portfolio Dashboard" />,
        children: [{ path: ROUTES.INVESTMENT_OVERSIGHT, element: <InvestmentOversight /> }],
      },
      {
        element: <AppLayout title="Forecast Variance" />,
        children: [{ path: ROUTES.FORECAST_VARIANCE, element: <ForecastVariance /> }],
      },
      {
        element: <AppLayout title="Geospatial Dashboard" />,
        children: [{ path: ROUTES.GEOSPATIAL, element: <Geospatial /> }],
      },
      {
        element: <AppLayout title="Geospatial Projects" />,
        children: [{ path: ROUTES.GEOSPATIAL_PROJECTS, element: <GeospatialProjects /> }],
      }
    ],
  },
];
